{
	"name": "battery",
	"size": [32, 32],
	"kit": "colony",
	"out": "items/power/battery",
	"replaces": "tools/generate_battery_sprites.py",
	"frames": { "count": 8, "drive": "charge" },
	"parts": [
		{ "shape": "posts", "inset": [3, 5, 3, 1], "columns": 1, "y": 2, "size": [3, 3], "gap": 2 },
		{
			"shape": "casing",
			"inset": [3, 5, 3, 1],
			"bevel": "left",
			"bevelWidth": 2,
			"lipHeight": 2,
			"lipRole": "rim",
			"accentRole": "trim_dark"
		},
		{ "shape": "panel", "inset": [5, 8, 4, 4], "role": "casing_shadow" },
		{ "shape": "meter", "inset": [6, 9, 5, 5], "value": "charge", "segments": 6, "ramp": "charge" },
		{ "shape": "border", "inset": [5, 8, 4, 4], "role": "trim" },
		{ "shape": "glyph", "id": "bolt", "at": [5, 3], "role": "trim_lit" },
		{
			"shape": "lamp",
			"at": [24, 5],
			"size": [3, 2],
			"value": "charge",
			"thresholds": [0.15, 0.5],
			"roles": ["bad", "brass", "good"]
		},
		{ "shape": "studs", "inset": [4, 30, 4, 0], "along": "bottom", "step": 4, "size": [2, 2], "role": "brass" }
	]
}
